import { gql } from '@apollo/client';

export const ALL_HIERARCHIY_LEVELS = gql`
  query AllHierarchyLevels($input: AllHierarchyLevelsInput!) {
    hierarchyLevels: allHierarchyLevels(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          value
          typeOfSite
          hasSubtypes
          subtypes
        }
      }
    }
  }
`;
